// Job List
const joblist = [
    {
        id: 1,
        logo: 'assets/images/companies/img-7.png',
        coverimage: 'assets/images/small/img-8.jpg',
        title: 'Product Designer',
        companyname: 'Themesbrand',
        content: "A UI/UX designer's job is to create user-friendly interfaces that enable users to understand how to use complex technical products. If you're passionate about the latest technology trends and devices, you'll find great fulfillment in being involved in the design process for the next hot gadget.",
        type: 'Full Time',
        experience: '1 - 2 Year',
        location: 'United Kingdom',
        applied: '74',
        date: '15 Sep, 2022',
        tags: ['Design', 'Remote', 'UI/UX Designer', 'Designer'],
        bookmark: true

    },
    {
        id: 2,
        logo: 'assets/images/companies/img-6.png',
        coverimage: 'assets/images/small/img-3.jpg',
        title: 'Project Manager',
        companyname: 'Syntyce Solutions',
        content: "In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best. But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated.",
        type: 'Freelance',
        experience: '1 Year',
        location: 'Stordorf, Germany',
        applied: '36',
        date: '14 Sep, 2022',
        tags: ['Design', 'Remote', 'UI/UX Designer', 'Designer'],
        bookmark: false
    },
    {
        id: 3,
        logo: 'assets/images/companies/img-5.png',
        coverimage: 'assets/images/small/img-7.jpg',
        title: 'Product Sales Specialist',
        companyname: 'Digitech Galaxy',
        content: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.",
        type: 'Part Time',
        experience: '0 - 5 Year',
        location: 'Cullera, Spain',
        applied: '79',
        date: '14 Sep, 2022',
        tags: ['Design', 'Remote', 'UI/UX Designer', 'Designer'],
        bookmark: false
    },
    {
        id: 4,
        logo: 'assets/images/companies/img-4.png',
        coverimage: 'assets/images/small/img-4.jpg',
        title: 'Marketing Director',
        companyname: 'Meta4Systems',
        content: "These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents to do what we like best, every pleasure is to be welcomed and every pain avoided. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure.",
        type: 'Internship',
        experience: 'Fresher',
        location: 'Vinninga, Sweden',
        applied: '134',
        date: '13 Sep, 2022',
        tags: ['Design', 'Remote', 'UI/UX Designer', 'Designer'],
        bookmark: false
    },
    {
        id: 5,
        logo: 'assets/images/companies/img-3.png',
        coverimage: 'assets/images/small/img-2.jpg',
        title: 'UI/UX designer',
        companyname: 'Nesta Technologies',
        content: "A UI/UX designer's job is to create user-friendly interfaces that enable users to understand how to use complex technical products. If you're passionate about the latest technology trends and devices, you'll find great fulfillment in being involved in the design process for the next hot gadget..",
        type: 'Full Time',
        experience: '2 Year',
        location: 'Escondido, California',
        applied: '640',
        date: '11 Sep, 2022',
        tags: ['Design', 'Remote', 'UI/UX Designer', 'Designer'],
        bookmark: false
    }
]

// Job Grid
const jobgrid = [
    {
        id: '0',
        logo: '',
        title: '',
        companyname: '',
        content: "",
        type: [],
        location: '',
        date: '',
    },
    {
        id: '1',
        logo: 'assets/images/companies/img-1.png',
        title: 'Education Training',
        companyname: 'Micro Design',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Freelance', 'Urgent'],
        location: 'Escondido,California',
        date: '15 Sep, 2022',
    },
    {
        id: '2',
        logo: 'assets/images/companies/img-2.png',
        title: 'Magento Developer',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Part Time', 'Freelance'],
        location: 'Stordorf, Germany',
        date: '15 Sep, 2022',
    },
    {
        id: '3',
        logo: 'assets/images/companies/img-3.png',
        title: 'Product Designer',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Private'],
        location: 'Cullera, Spain',
        date: '14 Sep, 2022',
    },
    {
        id: '4',
        logo: 'assets/images/companies/img-5.png',
        title: 'React Developer',
        companyname: 'iTest Factory',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Freelance', 'Urgent'],
        location: 'Haren, Germany',
        date: '13 Sep, 2022',
    },
    {
        id: '5',
        logo: 'assets/images/companies/img-6.png',
        title: 'UI/UX designer',
        companyname: 'Creative Team',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Part Time'],
        location: 'inninga, Sweden',
        date: '13 Sep, 2022',
    },
    {
        id: '6',
        logo: 'assets/images/companies/img-7.png',
        title: 'Marketing Director',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Freelance', 'Urgent'],
        location: 'Zhoukou, China',
        date: '12 Sep, 2022',
    },
    {
        id: '7',
        logo: 'assets/images/companies/img-8.png',
        title: 'Full Stack Engineer',
        companyname: 'Syntyce Solutions',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time'],
        location: 'Boroaia, Romania',
        date: '11 Sep, 2022',
    },
    {
        id: '8',
        logo: 'assets/images/companies/img-2.png',
        title: 'HTML Developer',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Part Time', 'Freelance'],
        location: 'Donsieders, Germany',
        date: '10 Sep, 2022',
    },
    {
        id: '9',
        logo: 'assets/images/companies/img-3.png',
        title: 'Business Associate',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Freelance', 'Urgent'],
        location: 'Sermerieu, France',
        date: '09 Sep, 2022',
    },
    {
        id: '10',
        logo: 'assets/images/companies/img-5.png',
        title: 'Assistant / Store Keeper',
        companyname: 'Force Medicines',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Part Time'],
        location: 'San Lorenzo, Philippines',
        date: '08 Sep, 2022',
    },
    {
        id: '11',
        logo: 'assets/images/companies/img-6.png',
        title: 'Product Sales Specialist',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Private'],
        location: 'Pazmand, Hungary',
        date: '08 Sep, 2022',
    }
]

// Related Job
const joboverview = [
    {
        id: '1',
        logo: 'assets/images/companies/img-1.png',
        title: 'Web designer',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Freelance', 'Urgent'],
        location: 'Escondido,California',
        date: '3 min ago',
    },
    {
        id: '2',
        logo: 'assets/images/companies/img-2.png',
        title: 'Marketing Director',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Part Time', 'Freelance'],
        location: 'Stordorf, Germany',
        date: '30 min ago',
    },
    {
        id: '3',
        logo: 'assets/images/companies/img-3.png',
        title: 'Product Sales Specialist',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Private'],
        location: 'Cullera, Spain',
        date: '2 days ago',
    },
    {
        id: '4',
        logo: 'assets/images/companies/img-1.png',
        title: 'Web designer',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Freelance', 'Urgent'],
        location: 'Escondido,California',
        date: '3 min ago',
    },
    {
        id: '5',
        logo: 'assets/images/companies/img-2.png',
        title: 'Marketing Director',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Part Time', 'Freelance'],
        location: 'Stordorf, Germany',
        date: '30 min ago',
    },
    {
        id: '6',
        logo: 'assets/images/companies/img-3.png',
        title: 'Product Sales Specialist',
        companyname: 'Themesbrand',
        content: "As a Product Designer, you will work within a Product Delivery Team fused with UX,engineering, product and data talent.",
        type: ['Full Time', 'Private'],
        location: 'Cullera, Spain',
        date: '2 days ago',
    }
]

export { joblist, jobgrid, joboverview }